// L'ajout rapide (lot 6.4) : un rappel en une phrase, ouvert par le raccourci de l'icône (Android) ou depuis l'app. Le
// cœur lit le jour, l'heure et la récurrence sans IA, et répond ce qu'il a compris ; le micro du clavier fait la dictée.

import { useState } from 'react';

import type { Actions } from '../App';
import { EnTeteRetour, Fenetre } from '../components';

export function RappelRapide({ actions }: { actions: Actions }) {
  const [texte, setTexte] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [notes, setNotes] = useState<string[]>([]);

  const ajouter = async () => {
    if (!texte.trim()) return;
    setEnvoi(true);
    try {
      const resume = await actions.rappelPhrase(texte);
      setNotes((n) => [resume ?? `Gardé hors ligne : « ${texte.trim()} ». Il partira au retour du réseau.`, ...n]);
      setTexte('');
    } catch (e) {
      actions.toast({ texte: (e as Error).message, erreur: true });
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <main className="ecran">
      <EnTeteRetour titre="Nouveau rappel" />
      <Fenetre>
        <form className="formulaire" onSubmit={(e) => { e.preventDefault(); void ajouter(); }}>
          <label className="champ-compte">
            En une phrase
            <textarea
              className="saisie texte" rows={2} autoFocus value={texte} maxLength={300}
              placeholder="Appeler le garage demain à 9h" onChange={(e) => setTexte(e.target.value)}
              // Entrée envoie (une phrase n'a pas besoin de saut de ligne) ; Maj+Entrée en garde un.
              onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); void ajouter(); } }}
              style={{ height: 'auto', minHeight: 72, padding: 12, resize: 'none' }}
            />
          </label>
          <button className="btn principal large" disabled={envoi || !texte.trim()}>Ajouter</button>
        </form>
        <p className="muted" style={{ margin: 0, fontSize: 12, lineHeight: 1.5 }}>
          Un jour (« demain », « vendredi », « le 12 »), une heure (« à 9h », « 18h30 »), ou une habitude (« tous les mardis »).
          Le micro du clavier fait la dictée.
        </p>
      </Fenetre>
      {notes.map((n, k) => <p key={k} className="message accent" style={{ fontSize: 14 }}>{n}</p>)}
      {notes.length > 0 && <a className="btn large" href="#/" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Retour à la journée</a>}
    </main>
  );
}
